import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthServerProvider} from '../../../../block/auth/auth-jwt.service';
import {WelcomeService} from '../../../welcome/welcome.service';


@Component({
  selector: 'app-password-reset-finish',
  templateUrl: './password-reset-finish.component.html',
})
export class PasswordResetFinishComponent implements OnInit {

  key: string;
  regularForm: FormGroup;

  event: any;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    public authService: AuthServerProvider,
    private welcomeService: WelcomeService,
  ) {
  }

  ngOnInit() {
    this.welcomeService.getEventDetail().subscribe((resEvent: any) => {
      this.event = resEvent;
    });
    this.route.queryParams.subscribe((params) => {
      this.key = params['key'];
    });
    this.regularForm = this.fb.group({
      password: [null, [Validators.required, Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,45}$')]],
      confirm: [null, [Validators.required]]
    }, {
      updateOn: 'blur',
      validator: this.compareEmailAndConfirm
    })
  }

  private compareEmailAndConfirm(c: AbstractControl) {
    const password = c.get('password').value;
    const confirm = c.get('confirm').value;
    if (!password || !confirm) {
      c.get('confirm').setErrors({required: true});
    } else if (password !== confirm) {
      c.get('confirm').setErrors({mismath: true});
    } else {
      c.get('confirm').setErrors(null);
    }
  }

  reset() {
    const password = this.regularForm.get('password').value;
    this.authService.finishResetPassword({key: this.key, newPassword: password}).subscribe(() => {
      this.router.navigate(['/login']);
    });
  }
}
